import React from 'react';
import "./Mailbox.css";
import MailboxEmpty from "./MailboxEmpty.mjs";
import TemplateItem from "./TemplateItem.mjs";

const G = window.glob;

const Templatebox = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('Templatebox');
	}
	componentDidMount() {

	}
	render() {
		const msgs = this.props.data && this.props.data.length ? this.props.data.filter( m => m?.id ) : [];
		return(
			<div className={"Mailbox Templatebox"} id={this.uid}>
				{ msgs.length ? (
					<div className={"MailboxItems TemplateboxItems"}>
						{
							msgs.map( (m,idx) => (
								<TemplateItem
									box={ this.props.box }
									key={ idx }
									data={ m }
									read={ true }
								/>
							))
						}
					</div>
				) : (
					<MailboxEmpty />
				) }
			</div>
		);
	}
}

export default Templatebox;